import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

type CorporateCountry = {
  country: string;
  percentage: string;
};

type CorporateCountriesTableProps = {
  values: CorporateCountry[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

const CorporateCountriesTable = ({
  values,
  setFieldValue,
}: CorporateCountriesTableProps) => {
  const handleAddRow = () => {
    const newRows = [...values, { country: "", percentage: "" }];
    setFieldValue("corporateCountries", newRows);
  };

  const handleChangeRow = (
    index: number,
    field: keyof CorporateCountry,
    value: string
  ) => {
    const newRows = values.map((row, idx) =>
      idx === index ? { ...row, [field]: value } : row
    );
    setFieldValue("corporateCountries", newRows);
  };

  const handleRemoveRow = (index: number) => {
    const newRows = values.filter((_, idx) => idx !== index);
    setFieldValue("corporateCountries", newRows);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: "lightgreen",
              "& .MuiTableCell-root": { fontWeight: "bold", color: "black" },
            }}
          >
            <TableRow>
              <TableCell>Country</TableCell>
              <TableCell align="right">%</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    fullWidth
                    placeholder="Country"
                    value={row.country}
                    onChange={(e) =>
                      handleChangeRow(index, "country", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    fullWidth
                    placeholder="%"
                    value={row.percentage}
                    onChange={(e) =>
                      handleChangeRow(index, "percentage", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleRemoveRow(index)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="outlined" onClick={handleAddRow} sx={{ mt: 2 }}>
        Add Row
      </Button>
    </>
  );
};

export default CorporateCountriesTable;
